<button
    [ngStyle]="dynamicStyles()"
    [disabled]="btnLoading"
    (click)="buttonClicked()"
    (keyup.enter)="buttonClicked()"
>
<span>{{(btnProperties ? btnProperties.btnName : '') | driveLabelPipe}}</span>
</button>